import { useEffect } from "react";
import { useLocation } from "react-router-dom";

import {
  COPILOT_PREVIEW_FIXTURES,
  isCopilotPreviewVariant,
} from "../lib/copilot-preview-fixtures";
import { IS_PREVIEW } from "../lib/pro-mode";
import { useProChatStore } from "../stores/proChat";

// IS_PREVIEW-only seam (plan 188 W2-M9, task 808): seeds the copilot chat
// store with a canned conversation when `?copilotDemo=<variant>` is present
// in the URL, so the dock/drawer/full-page/confirm-card surfaces can be
// screenshotted without a backend or a live WS turn. No-ops outside preview
// mode and outside the query param — never touches the authenticated path.
export function useCopilotPreviewFixture(): void {
  const { search } = useLocation();

  useEffect(() => {
    if (!IS_PREVIEW) return;
    const params = new URLSearchParams(search);
    const variant = params.get("copilotDemo");
    if (!isCopilotPreviewVariant(variant)) return;

    useProChatStore.getState().loadHistory({
      conversationId: `fixture-${variant}`,
      messages: COPILOT_PREVIEW_FIXTURES[variant],
      dockItems: [],
    });
  }, [search]);
}
